import React, { useRef } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { useCompanyModel } from "../companyModel";
import { YhForm } from "@/components/YhFormBox";
import { IYhForm, IYhFormRef, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { ICompanyDetail } from "../companyTypes";
import { message } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import useGlobalModel from "@/model/globalModel";
export function DetailDrawer() {
    const {
        visibleDrawer: { visible, mode },
        selectedRow,
        setIVisibleDrawer,
        editDetail,
        insertDetail,
        md5FormVal, setMd5FormVal
    } = useCompanyModel();
    const { user } = useGlobalModel();
    const { getSelectedDictOne, getTreeNodeName } = useDictModel()
    const formRef = useRef<IYhFormRef>();
    const onCancel = () => {
        setIVisibleDrawer()
        setMd5FormVal([])
    }
    const onSubmit = () => {
        // setIVisibleDrawer()
        formRef.current?.validateFields().then((val: any) => {
            let { columnCode } = val;
            let columnName = getTreeNodeName(columnCode)
            mode === "edit" ? editDetail({ ...val, columnName }) : insertDetail({ ...val, columnName })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    const onSetFieldsValue = (formValues: { [key: string]: any }, isFormItem: boolean = true) => {
        setMd5FormVal(formValues.image)
    }
    const formConfig: IYhForm<ICompanyDetail> = {
        formRef,
        labelCol: { span: 6 },
        // formValues: {},
        formValues: mode === "edit" || mode === "look" ? selectedRow[0] : { createUser: user.userName },
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "标题",
                fieldName: "title",
                disable: mode === "look",
                rules: [{ required: true, message: "请输入标题" }]
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "业务范围",
                fieldName: "columnCode",
                disable: mode === "look",
                allowClear: true,
                options: getSelectedDictOne(DictCodeEnmu.BUS),
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "业务资质",
                fieldName: "type",
                allowClear: true,
                options: getSelectedDictOne(DictCodeEnmu.COLUMN).filter(item => item.value === 'medal' || item.value === 'business'),
                disable: mode === "look",
                span: 24,
            },
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "图片上传",
                fieldName: "image",
                span: 24,
                md5List: md5FormVal,
                rules: [{ required: true, message: "请输入图片上传" }],
                onSetFieldsValue
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                disable: mode === "look",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                span: 24,
                disable: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                span: 24,
                disable: true
            },
        ]
    }
    return (
        <YHDrawer
            {...{
                title: `公司荣誉${mode === "add" ? '新增' : mode === "edit" ? '编辑' : '查看'}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit,
                showFooter: mode !== "look"
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}